import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Facebook, Instagram, Share2 } from "lucide-react";
import { api } from "@/lib/api";

let assocPromise = null;
const listeners = new Set();
const loadAssoc = () => {
  assocPromise = assocPromise || api.get("/associazione").then((r) => r.data).catch(() => ({}));
  return assocPromise;
};
export const refreshAssoc = (data) => {
  assocPromise = Promise.resolve(data);
  listeners.forEach((fn) => fn(data));
};

const SOCIAL = [["facebook", "Facebook", Facebook, "hover:bg-[#1877F2]"], ["instagram", "Instagram", Instagram, "hover:bg-gradient-to-tr hover:from-[#F58529] hover:via-[#DD2A7B] hover:to-[#8134AF]"]];

export const SocialLinks = ({ d, dark = false, size = "h-9 w-9" }) => {
  const [assoc, setAssoc] = useState(d || null);
  useEffect(() => {
    if (d) return undefined;
    loadAssoc().then(setAssoc);
    listeners.add(setAssoc);
    return () => listeners.delete(setAssoc);
  }, [d]);
  const items = SOCIAL.filter(([k]) => assoc?.[k]);
  if (!items.length) return null;
  return (
    <div className="flex items-center gap-2" data-testid="social-links">
      {items.map(([k, label, Icon, hover]) => (
        <a key={k} href={assoc[k]} target="_blank" rel="noopener noreferrer" aria-label={label} title={label} data-testid={`social-${k}-link`}
          className={`${size} grid place-items-center rounded-full transition-colors ${dark ? "bg-white/10 text-white" : "bg-slate-200 text-[#0B192C]"} ${hover} hover:text-white`}>
          <Icon className="h-4 w-4" />
        </a>
      ))}
    </div>
  );
};

const shareInstagram = async (url, title) => {
  if (navigator.share) {
    try {
      await navigator.share({ title, url });
      return;
    } catch (e) {
      if (e.name === "AbortError") return;
    }
  }
  try {
    await navigator.clipboard.writeText(url);
    toast.success("Link copiato: incollalo nel tuo post o nella tua storia Instagram");
  } catch {
    toast.message(`Copia questo link: ${url}`);
  }
  window.open("https://www.instagram.com/", "_blank", "noopener");
};

export const ShareButtons = ({ id, title }) => {
  const url = `${window.location.origin}/associazione/news/${id}`;
  const btn = "inline-flex items-center gap-2 rounded-full px-4 h-10 text-sm font-medium text-white transition-[filter,transform] hover:brightness-110 active:scale-95";
  return (
    <div className="mt-10 pt-6 border-t flex flex-wrap items-center gap-3" data-testid="news-share">
      <span className="text-sm text-muted-foreground inline-flex items-center gap-1 mr-1"><Share2 className="h-4 w-4" />Condividi</span>
      <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer"
        className={`${btn} bg-[#1877F2]`} data-testid="news-share-facebook"><Facebook className="h-4 w-4" />Facebook</a>
      <button type="button" onClick={() => shareInstagram(url, title)} data-testid="news-share-instagram"
        className={`${btn} bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF]`}><Instagram className="h-4 w-4" />Instagram</button>
    </div>
  );
};
